module.exports = __webpack_public_path__ + "static/media/ycard_visa.bc0146fa.svg";